var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import BackArrow from "react-icons/lib/md/arrow-back";
import Info from "react-icons/lib/md/info-outline";
import Menu from "react-icons/lib/md/menu";
import AngleLeft from "react-icons/lib/fa/angle-left";
import AngleRight from "react-icons/lib/fa/angle-right";
import DealHighlightTypes from "@irati-web/perks/src/constants/dealHighlightTypes";
import EditPencil from "react-icons/lib/fa/edit";
import Ellipsis from "react-icons/lib/fa/ellipsis-h";
import OldComment from "react-icons/lib/fa/comment-o";
import OldCommented from "react-icons/lib/fa/comment";
import OldReward from "react-icons/lib/fa/gift";
import Pause from "react-icons/lib/fa/pause";
import Play from "react-icons/lib/fa/play";
import Trashcan from "react-icons/lib/fa/trash-o";
import UpArrow from "react-icons/lib/fa/chevron-up";
import Vote from "react-icons/lib/fa/heart-o";
import Voted from "react-icons/lib/fa/heart";
import Refresh from "react-icons/lib/fa/refresh";
import AddAdmin from "./customIcons/AddAdmin";
import AddBookmark from "./customIcons/AddBookmark";
import AddComment from "./customIcons/AddComment";
import AddEmoji from "./customIcons/AddEmoji";
import AddReward from "./customIcons/AddReward";
import Announcement from "./customIcons/Announcement";
import Apps from "./customIcons/Apps";
import Archive from "./customIcons/Archive";
import Attachment from "./customIcons/Attachment";
import Blog from "./customIcons/Blog";
import CircleHollow from "./customIcons/CircleHollow";
import CircleTick from "./customIcons/CircleTick";
import Clipboard from "./customIcons/Clipboard";
import Clock from "./customIcons/Clock";
import Close from "./customIcons/Close";
import Comment from "./customIcons/Comment";
import Coupon from "./customIcons/Ticket";
import CustomReward from "./customIcons/CustomReward";
import Delete from "./customIcons/Delete";
import DisabledEditQuestion from "./customIcons/DisabledEditQuestion";
import DoctorCareAnywhere from "./customIcons/DoctorCareAnywhere";
import DotDotDot from "./customIcons/DotDotDot";
import DownArrow from "./customIcons/DownArrow";
import DownloadFile from "./customIcons/DownloadFile";
import Duplicate from "./customIcons/Duplicate";
import EditQuestion from "./customIcons/EditQuestion";
import Emoji from "./customIcons/Emoji";
import EmojiActive from "./customIcons/EmojiActive";
import Event from "./customIcons/Event";
import EyeSlash from "./customIcons/EyeSlash";
import FileDownload from "./customIcons/FileDownload";
import FilterActive from "./customIcons/FilterActive";
import GeoArrow from "./customIcons/GeoArrow";
import GeoPin from "./customIcons/GeoPin";
import HeartOutline from "./customIcons/HeartOutline";
import Help from "./customIcons/Help";
import I from "./customIcons/I";
import Instant from "./customIcons/Instant";
import Landscape from "./customIcons/Landscape";
import Launch from "./customIcons/Launch";
import LogoBox from "./customIcons/LogoBox";
import Logout from "./customIcons/Logout";
import MobileAppOnly from "./customIcons/MobileAppOnly";
import MobileSecondaryNav from "./customIcons/MobileSecondaryNav";
import More from "./customIcons/More";
import MyPerks from "./customIcons/MyPerks";
import MyRecognition from "./customIcons/MyRecognition";
import MySurveys from "./customIcons/MySurveys";
import Newsletter from "./customIcons/Newsletter";
import NewTab from "./customIcons/NewTab";
import OneHour from "./customIcons/Time";
import Online from "./customIcons/Online";
import Padlock from "./customIcons/Padlock";
import Party from "./customIcons/Party";
import Payment from "./customIcons/Payment";
import People from "./customIcons/People";
import Perks from "./customIcons/Perks";
import PerksGO from "./customIcons/PerksGO";
import Person from "./customIcons/Person";
import Physical from "./customIcons/TopUpCard";
import Pin from "./customIcons/Pin";
import PinFilled from "./customIcons/PinFilled";
import PlayVideo from "./customIcons/PlayVideo";
import Poll from "./customIcons/Poll";
import ProductsInsights from "./customIcons/Product-Insights";
import ProductsMedical from "./customIcons/Product-Medical";
import ProductsPerks from "./customIcons/Product-Perks";
import ProductsRecognition from "./customIcons/Product-Recognition";
import Question from "./customIcons/Question";
import Reminder from "./customIcons/Reminder";
import RemoveBookmark from "./customIcons/RemoveBookmark";
import Report from "./customIcons/Report";
import Restore from "./customIcons/Restore";
import RewardActive from "./customIcons/RewardActive";
import RightArrow from "./customIcons/RightArrow";
import SeeResults from "./customIcons/SeeResults";
import SendExampleSurvey from "./customIcons/SendExampleSurvey";
import Share from "./customIcons/Share";
import SharedUser from "./customIcons/SharedUser";
import SimpleFavourite from "./customIcons/SimpleHeartFilled";
import SimpleFavouriteOutline from "./customIcons/SimpleHeart";
import Sort from "./customIcons/Sort";
import Stop from "./customIcons/Stop";
import SummaryComments from "./customIcons/SummaryComments";
import SummaryRecognitions from "./customIcons/SummaryRecognitions";
import SummaryTrophies from "./customIcons/SummaryTrophies";
import Tag from "./customIcons/Tag";
import TimeLimitedPerk from "./customIcons/TimeLimitedPerk";
import User from "./customIcons/User";
import Values from "./customIcons/Values";
import Visibility from "./customIcons/Visibility";
import AdminMyPeople from "./customIcons/AdminMyPeople";
import AdminMyTeam from "./customIcons/AdminMyTeam";
import AdminCustomisation from "./customIcons/AdminCustomisation";
import AdminRolesPermissions from "./customIcons/AdminRolesPermissions";
import AdminLoginIntegrations from "./customIcons/AdminLoginIntegrations";
import AdminReports from "./customIcons/AdminReports";
import AdminHelp from "./customIcons/AdminHelp";
// ================================================================ New icons
import Analytics from "./customIcons/svg/Analytics";
import ArrowDown from "./customIcons/svg/ArrowDown";
import ArrowLeft from "./customIcons/svg/ArrowLeft";
import ArrowRight from "./customIcons/svg/ArrowRight";
import ArrowUp from "./customIcons/svg/ArrowUp";
import Bin from "./customIcons/svg/Bin";
import Bookmark from "./customIcons/svg/Bookmark";
import BookmarkFill from "./customIcons/svg/BookmarkFill";
import Calendar from "./customIcons/svg/Calendar";
import Categories from "./customIcons/svg/Categories";
import Checklist from "./customIcons/svg/Checklist";
import ChevronDown from "./customIcons/svg/ChevronDown";
import ChevronLeft from "./customIcons/svg/ChevronLeft";
import ChevronRight from "./customIcons/svg/ChevronRight";
import ChevronUp from "./customIcons/svg/ChevronUp";
import CircleAlert from "./customIcons/svg/CircleAlert";
import CircleAlertFill from "./customIcons/svg/CircleAlertFill";
import CircleCrossFill from "./customIcons/svg/CircleCrossFill";
import CircleDisable from "./customIcons/svg/CircleDisable";
import CircleFastForward from "./customIcons/svg/CircleFastForward";
import CircleInformation from "./customIcons/svg/CircleInformation";
import CirclePause from "./customIcons/svg/CirclePause";
import CirclePlay from "./customIcons/svg/CirclePlay";
import CircleQuestion from "./customIcons/svg/CircleQuestion";
import CircleTickFill from "./customIcons/svg/CircleTickFill";
import CompanyBenefit from "./customIcons/svg/CompanyBenefit";
import Cross from "./customIcons/svg/Cross";
import Document from "./customIcons/svg/Document";
import DownloadReport from "./customIcons/svg/DownloadReport";
import Edit from "./customIcons/svg/Edit";
import Email from "./customIcons/svg/Email";
import Export from "./customIcons/svg/Export";
import Eye from "./customIcons/svg/Eye";
import EyeDisabled from "./customIcons/svg/EyeDisabled";
import Favourite from "./customIcons/svg/Favourite";
import FavouriteFill from "./customIcons/svg/FavouriteFill";
import Funnel from "./customIcons/svg/Funnel";
import Filter1 from "./customIcons/svg/Filter-1";
import Filter2 from "./customIcons/svg/Filter-2";
import Filter3 from "./customIcons/svg/Filter-3";
import FilterHighToLow from "./customIcons/svg/FilterHighToLow";
import FilterLowToHigh from "./customIcons/svg/FilterLowToHigh";
import FilterUpAndDown from "./customIcons/svg/FilterUpAndDown";
import GenerateReport from "./customIcons/svg/GenerateReport";
import Home from "./customIcons/svg/Home";
import Information from "./customIcons/svg/Information";
import Label from "./customIcons/svg/Label";
import LightBulb from "./customIcons/svg/LightBulb";
import Location from "./customIcons/svg/Location";
import Minus from "./customIcons/svg/Minus";
import Notification from "./customIcons/svg/Notification";
import Pending from "./customIcons/svg/Pending";
import Plus from "./customIcons/svg/Plus";
import Profile from "./customIcons/svg/Profile";
import Results from "./customIcons/svg/Results";
import Reward from "./customIcons/svg/Reward";
import Reward2 from "./customIcons/svg/Reward-2";
import Search from "./customIcons/svg/Search";
import Send from "./customIcons/svg/Send";
import Settings from "./customIcons/svg/Settings";
import Speech from "./customIcons/svg/Speech";
import SpeechPlus from "./customIcons/svg/SpeechPlus";
import Star from "./customIcons/svg/Star";
import StarFill from "./customIcons/svg/StarFill";
import Survey from "./customIcons/svg/Survey";
import Tick from "./customIcons/svg/Tick";
import UploadReport from "./customIcons/svg/UploadReport";
import Wallet from "./customIcons/svg/Wallet";
import IconTypes from "./IconTypes.enum";
var EmptyIcon = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var iconPicker = function (icon) {
    switch (icon) {
        case IconTypes.addAdmin:
            return AddAdmin;
        case IconTypes.apps:
            return Apps;
        case IconTypes.menu:
            return Menu;
        case IconTypes.info:
            return Info;
        case IconTypes.backArrow:
            return BackArrow;
        case IconTypes.upArrow:
            return UpArrow;
        case IconTypes.downArrow:
            return DownArrow;
        case IconTypes.rightArrow:
            return RightArrow;
        case IconTypes.payment:
            return Payment;
        case IconTypes.trashcan:
            return Trashcan;
        case IconTypes.angleLeft:
            return AngleLeft;
        case IconTypes.angleRight:
            return AngleRight;
        case IconTypes.favouriteOutline:
            return Favourite;
        case IconTypes.simpleFavourite:
            return SimpleFavourite;
        case IconTypes.simpleFavouriteOutline:
            return SimpleFavouriteOutline;
        case IconTypes.newTab:
            return NewTab;
        case IconTypes.landscape:
            return Landscape;
        case IconTypes.question:
            return Question;
        case IconTypes.circleTick:
            return CircleTick;
        case IconTypes.circleHollow:
            return CircleHollow;
        case IconTypes.perks:
            return Perks;
        case IconTypes.logoBox:
            return LogoBox;
        case IconTypes.close:
            return Close;
        case IconTypes.oldComment:
            return OldComment;
        case IconTypes.oldCommented:
            return OldCommented;
        case IconTypes.comment:
            return Comment;
        case IconTypes.addComment:
            return AddComment;
        case IconTypes.emoji:
            return Emoji;
        case IconTypes.emojiActive:
            return EmojiActive;
        case IconTypes.addEmoji:
            return AddEmoji;
        case IconTypes.customReward:
            return CustomReward;
        case IconTypes.rewardActive:
            return RewardActive;
        case IconTypes.addReward:
            return AddReward;
        case IconTypes.vote:
            return Vote;
        case IconTypes.voted:
            return Voted;
        case IconTypes.oldReward:
            return OldReward;
        case IconTypes.play:
            return Play;
        case IconTypes.pause:
            return Pause;
        case IconTypes.attachment:
            return Attachment;
        case IconTypes.pin:
            return Pin;
        case IconTypes.pinFilled:
            return PinFilled;
        case IconTypes.visibility:
            return Visibility;
        case DealHighlightTypes.DIGITAL:
            return Coupon;
        case DealHighlightTypes.COMPANY_BENEFIT:
            return CompanyBenefit;
        case DealHighlightTypes.PHYSICAL:
            return Physical;
        case DealHighlightTypes.COUPON:
            return Coupon;
        case DealHighlightTypes.INSTANT:
            return Instant;
        case DealHighlightTypes.ONE_HOUR:
            return OneHour;
        case DealHighlightTypes.APP_ONLY:
            return MobileAppOnly;
        case DealHighlightTypes.TIME_LIMIT_24_HOUR:
            return TimeLimitedPerk;
        case IconTypes.perksGO:
            return PerksGO;
        case IconTypes.geoPin:
            return GeoPin;
        case IconTypes.geoArrow:
            return GeoArrow;
        case IconTypes.summaryComments:
            return SummaryComments;
        case IconTypes.summaryRecognitions:
            return SummaryRecognitions;
        case IconTypes.summaryTrophies:
            return SummaryTrophies;
        case IconTypes.dotDotDot:
            return DotDotDot;
        case IconTypes.i:
            return I;
        case IconTypes.padlock:
            return Padlock;
        case IconTypes.person:
            return Person;
        case IconTypes.people:
            return People;
        case IconTypes.sendExampleSurvey:
            return SendExampleSurvey;
        case IconTypes.stop:
            return Stop;
        case IconTypes.duplicate:
            return Duplicate;
        case IconTypes.archive:
            return Archive;
        case IconTypes.launch:
            return Launch;
        case IconTypes.seeResults:
            return SeeResults;
        case IconTypes.editQuestion:
            return EditQuestion;
        case IconTypes.disabledEditQuestion:
            return DisabledEditQuestion;
        case IconTypes.eyeSlash:
            return EyeSlash;
        case IconTypes.restore:
            return Restore;
        case IconTypes.delete:
            return Delete;
        case IconTypes.mySurveys:
            return MySurveys;
        case IconTypes.more:
            return More;
        case IconTypes.ellipsis:
            return Ellipsis;
        case IconTypes.report:
            return Report;
        case IconTypes.poll:
            return Poll;
        case IconTypes.share:
            return Share;
        case IconTypes.sharedUser:
            return SharedUser;
        case IconTypes.heartOutline:
            return HeartOutline;
        case IconTypes.tag:
            return Tag;
        case IconTypes.sort:
            return Sort;
        case IconTypes.filterActive:
            return FilterActive;
        case IconTypes.removeBookmark:
            return RemoveBookmark;
        case IconTypes.addBookmark:
            return AddBookmark;
        case IconTypes.user:
            return User;
        case IconTypes.logout:
            return Logout;
        case IconTypes.help:
            return Help;
        case IconTypes.myPerks:
            return MyPerks;
        case IconTypes.myRecognition:
            return MyRecognition;
        case IconTypes.dca:
            return DoctorCareAnywhere;
        case IconTypes.mobileSecondaryNav:
            return MobileSecondaryNav;
        case IconTypes.editPencil:
            return EditPencil;
        case IconTypes.downloadFile:
            return DownloadFile;
        case IconTypes.productsPerks:
            return ProductsPerks;
        case IconTypes.productsInsights:
            return ProductsInsights;
        case IconTypes.productsMedical:
            return ProductsMedical;
        case IconTypes.productsRecognition:
            return ProductsRecognition;
        case IconTypes.announcement:
            return Announcement;
        case IconTypes.event:
            return Event;
        case IconTypes.values:
            return Values;
        case IconTypes.party:
            return Party;
        case IconTypes.playVideo:
            return PlayVideo;
        case IconTypes.reminder:
            return Reminder;
        case IconTypes.clipboard:
            return Clipboard;
        case IconTypes.blog:
            return Blog;
        case IconTypes.clock:
            return Clock;
        case IconTypes.newsletter:
            return Newsletter;
        case IconTypes.fileDownload:
            return FileDownload;
        case IconTypes.online:
            return Online;
        case IconTypes.refresh:
            return Refresh;
        case IconTypes.adminMyPeople:
            return AdminMyPeople;
        case IconTypes.adminMyTeam:
            return AdminMyTeam;
        case IconTypes.adminCustomisation:
            return AdminCustomisation;
        case IconTypes.adminRolesPermission:
            return AdminRolesPermissions;
        case IconTypes.adminLoginIntegrations:
            return AdminLoginIntegrations;
        case IconTypes.adminReports:
            return AdminReports;
        case IconTypes.adminHelp:
            return AdminHelp;
        // ============================================================ COMPONENT LIBRARY ICON SET
        case IconTypes.analytics:
            return Analytics;
        case IconTypes.arrowDown:
            return ArrowDown;
        case IconTypes.arrowLeft:
            return ArrowLeft;
        case IconTypes.arrowRight:
            return ArrowRight;
        case IconTypes.arrowUp:
            return ArrowUp;
        case IconTypes.bin:
            return Bin;
        case IconTypes.bookmark:
            return Bookmark;
        case IconTypes.bookmarkFill:
            return BookmarkFill;
        case IconTypes.calendar:
            return Calendar;
        case IconTypes.categories:
            return Categories;
        case IconTypes.checklist:
            return Checklist;
        case IconTypes.chevronDown:
            return ChevronDown;
        case IconTypes.chevronLeft:
            return ChevronLeft;
        case IconTypes.chevronRight:
            return ChevronRight;
        case IconTypes.chevronUp:
            return ChevronUp;
        case IconTypes.circleAlert:
            return CircleAlert;
        case IconTypes.circleAlertFill:
            return CircleAlertFill;
        case IconTypes.circleCrossFill:
            return CircleCrossFill;
        case IconTypes.circleDisable:
            return CircleDisable;
        case IconTypes.circleFastForward:
            return CircleFastForward;
        case IconTypes.circleInformation:
            return CircleInformation;
        case IconTypes.circlePause:
            return CirclePause;
        case IconTypes.circlePlay:
            return CirclePlay;
        case IconTypes.circleQuestion:
            return CircleQuestion;
        case IconTypes.circleTickFill:
            return CircleTickFill;
        case IconTypes.companyBenefit:
            return CompanyBenefit;
        case IconTypes.cross:
            return Cross;
        case IconTypes.document:
            return Document;
        case IconTypes.downloadReport:
            return DownloadReport;
        case IconTypes.edit:
            return Edit;
        case IconTypes.email:
            return Email;
        case IconTypes.export:
            return Export;
        case IconTypes.eye:
            return Eye;
        case IconTypes.eyeDisabled:
            return EyeDisabled;
        case IconTypes.favourite:
            return Favourite;
        case IconTypes.favouriteFill:
            return FavouriteFill;
        case IconTypes.funnel:
            return Funnel;
        case IconTypes.filter1:
            return Filter1;
        case IconTypes.filter2:
            return Filter2;
        case IconTypes.filter3:
            return Filter3;
        case IconTypes.filterHighToLow:
            return FilterHighToLow;
        case IconTypes.filterLowToHigh:
            return FilterLowToHigh;
        case IconTypes.filterUpAndDown:
            return FilterUpAndDown;
        case IconTypes.generateReport:
            return GenerateReport;
        case IconTypes.home:
            return Home;
        case IconTypes.information:
            return Information;
        case IconTypes.label:
            return Label;
        case IconTypes.lightBulb:
            return LightBulb;
        case IconTypes.location:
            return Location;
        case IconTypes.minus:
            return Minus;
        case IconTypes.notification:
            return Notification;
        case IconTypes.pending:
            return Pending;
        case IconTypes.plus:
            return Plus;
        case IconTypes.profile:
            return Profile;
        case IconTypes.results:
            return Results;
        case IconTypes.reward:
            return Reward;
        case IconTypes.reward2:
            return Reward2;
        case IconTypes.search:
            return Search;
        case IconTypes.send:
            return Send;
        case IconTypes.settings:
            return Settings;
        case IconTypes.speech:
            return Speech;
        case IconTypes.speechPlus:
            return SpeechPlus;
        case IconTypes.star:
            return Star;
        case IconTypes.starFill:
            return StarFill;
        case IconTypes.survey:
            return Survey;
        case IconTypes.tick:
            return Tick;
        case IconTypes.uploadReport:
            return UploadReport;
        case IconTypes.wallet:
            return Wallet;
        default:
            return EmptyIcon;
    }
};
export var isChevron = function (icon) {
    var chevrons = [IconTypes.chevronDown, IconTypes.chevronLeft, IconTypes.chevronRight, IconTypes.chevronUp];
    return chevrons.includes(icon);
};
var templateObject_1;
